import { createContext, useContext } from "react";

// ─────────────────────────────────────────────────────────────────────────────
// Contexto da sessão do Portal do Paciente (separado do provider para o ESLint
// react-refresh não reclamar de exportar hook + componente no mesmo arquivo).
// ─────────────────────────────────────────────────────────────────────────────

export interface PatientCase {
  id: number;
  patient_name: string;
  patient_email: string;
  patient_phone: string;
  patient_cpf: string;
  status: string;
  password?: string;
  doctor_id?: string;
  patient_data_nascimento?: string | null;
  patient_sexo?: string | null;
  patient_city?: string | null;
  patient_state?: string | null;
  patient_cep?: string | null;
  patient_street?: string | null;
  patient_neighborhood?: string | null;
  patient_number?: string | null;
  whatsapp_opt_status?: "received" | "discarded" | null;
}

export interface PatientSessionContextValue {
  /** Paciente autenticado em memória (ou null). */
  patient: PatientCase | null;
  /** True apenas enquanto ainda não se sabe se existe sessão válida. */
  sessionLoading: boolean;
  /** Define o paciente (persiste token/cache). Usado em login/cadastro/atualização. */
  setPatient: (p: PatientCase | null) => void;
  /** Atualiza os dados do paciente em segundo plano — NUNCA liga o loading. */
  refreshPatient: () => Promise<PatientCase | null>;
  /** Restaura a sessão a partir do token/cache (idempotente). */
  restorePatient: () => Promise<void>;
  /** Encerra a sessão (limpa token + cache + estado). */
  logout: () => void;
}

export const PatientSessionContext = createContext<PatientSessionContextValue | null>(null);

export function usePatientSession(): PatientSessionContextValue {
  const ctx = useContext(PatientSessionContext);
  if (!ctx) {
    throw new Error("usePatientSession deve ser usado dentro de <PatientSessionProvider>");
  }
  return ctx;
}
